import { useParams } from "next/navigation";
import z from "zod";

export const useLocaleStringParam = () => {
  return z.string().parse(useParams()?.localeString);
};
